export const BISContent = {
  heroContent: {
    title: "ALL-IN-ONE BARANGAY MANAGEMENT SYSTEM",
    description:
      "Transform your barangay operations with our integrated platform that handles resident profiling, business management, and comprehensive data analytics.",
    backgroundImage: "/assets/images/barangayIF.jpg",
  },

  footerContent: {
    backgroundColor: "#96B596",
    text: "© 2025 Tenth Corporation Inc. All Rights Reserved",
  },

  overviewModules: [
    {
      title: "Resident Profiling",
      icon: "bi-people-fill",
      features: [
        "Complete Demographic Information",
        "Physical Information Tracking",
        "Fiscal and Political Data",
        "Historical Records Management",
        "Services and Awards Tracking",
      ],
    },
    {
      title: "Business Profiling",
      icon: "bi-buildings-fill",
      features: [
        "Business Registration Management",
        "Permit and Licensing Tracking",
        "Business Classification System",
        "Revenue Monitoring",
        "Compliance Management",
      ],
    },
    {
      title: "Data Management & Analytics",
      icon: "bi-bar-chart-line-fill",
      features: [
        "Real-Time Data Updates",
        "Interactive Dashboard",
        "Comprehensive Reporting",
        "Data Visualization Tools",
        "Export and Integration Capabilities",
      ],
    },
    {
      title: "Digital Services",
      icon: "bi-globe",
      features: [
        "Online Certificate Issuance",
        "Digital Payment Processing",
        "QR code Authentication",
        "Mobile-Responsive Design",
        "24/7 Accessibility",
      ],
    },
  ],

  keyBenefits: [
    {
      icon: "bi-gear-fill",
      title: "Process Automation",
      description:
        "Eliminates manual data entry and reduces processing time by 80%",
    },
    {
      icon: "bi-shield-lock-fill",
      title: "Data Security",
      description:
        "Secure cloud-based storage with backup and recovery systems",
    },
    {
      icon: "bi-universal-access",
      title: "Accessibility",
      description: "Available 24/7 on any device with internet connection",
    },
    {
      icon: "bi-wallet2",
      title: "Cost Effective",
      description: "Reduces operational costs and improves resource allocation",
    },
  ],
  processFlow: {
    image: "/assets/images/ProcessFlow.png",
  },
  implementationStats: [
  { value: "42k+", label: "Barangays Profile" },
  { value: "100%", label: "MEMO Compliance" },
  { value: "80%", label: "Time Reduction" },
  { value: "24/7", label: "System Availability" },
],
};
